document.addEventListener('DOMContentLoaded', function () {  
  // start mobile-navigation.liquid    ********************************************
  
  const plusSVG = '<svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="4.67676" y1="1.09279e-08" x2="4.67676" y2="8" stroke="black" stroke-width="0.5"/><line x1="8.42676" y1="4.25" x2="0.426758" y2="4.25" stroke="black" stroke-width="0.5"/></svg>';
  const minusSVG = '<span>−</span>';
 
  const topLevelItems = document.querySelectorAll('.first-level-menu-item');
  topLevelItems.forEach((item) => {
    const summary = item.querySelector('summary');
    const iconSpan = summary.querySelector('.accordion-icon');
    iconSpan.innerHTML = plusSVG;
    item.addEventListener('toggle', function () {
      // Removed logic that closes other accordions
      if (item.open) {
        iconSpan.innerHTML = minusSVG;
      } else {
        iconSpan.innerHTML = plusSVG;
      } 
      const submenu = item.querySelector('.menu-drawer__submenu');
      if (submenu) {
        if (item.open) {
          submenu.classList.add('menu-drawer__submenu--visible');
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
          submenu.classList.remove('menu-drawer__submenu--visible');
          submenu.style.maxHeight = null;
        }
      }
    });
  });
 
  const secondLevelItems = document.querySelectorAll('.second-level-menu-item details');
  secondLevelItems.forEach((item) => {
    const summary = item.querySelector('summary');
    const iconSpan = summary.querySelector('.accordion-icon');
    iconSpan.innerHTML = plusSVG;
    item.addEventListener('toggle', function () {
      // Removed logic that closes other accordions
      if (item.open) {
        iconSpan.innerHTML = minusSVG;
      } else {
        iconSpan.innerHTML = plusSVG;
      } 
      const submenu = item.querySelector('.menu-drawer__submenu_grandchild');
      if (submenu) {
        if (item.open) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
          submenu.style.maxHeight = null;
        }
      }
    });
  });
 
  document.querySelectorAll('.upper-content .close-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const closeMenuBtn = document.querySelector('.close-menu-mb');
      if (closeMenuBtn) {
        closeMenuBtn.click();
      } else {
        const drawer = document.querySelector('.menu-drawer__navigation-container');
        if (drawer) drawer.style.display = 'none';
      }
    });
  });

  // end mobile-navigation.liquid     ********************************************


  const toggleBtn = document.querySelector('[data-menu-mb-toogle-custom]');
  const hamburgerWrapper = document.getElementById('hamburger');
  const drawer = document.querySelector('.menu-drawer__navigation-container');  

  if (toggleBtn && hamburgerWrapper) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault(); 
      hamburgerWrapper.classList.toggle('active'); 
      if (drawer) {
        drawer.classList.toggle('open');
      }
    });
  }
  
});